import React, { forwardRef } from "react";
import classNames from "classnames";

type Props = {
  className?: string;
  children: React.ReactNode;
};

const FormField = forwardRef<HTMLDivElement, Props>(
  ({ className, ...others }, ref) => {
    const classes = classNames("form__field form__field--js", className);

    return <div className={classes} ref={ref} {...others} />;
  },
);

export default FormField;
